<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="fixed inset-0 z-30 flex items-center justify-center bg-transparent"
    >
      <div
        class="fixed top-0 z-10 h-full w-full bg-dark-gray bg-opacity-50"
        @click="$emit('click-outside-modal')"
      />
      <div class="relative z-10 scroll-auto">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    visible: Boolean,
  },
  emits: ['click-outside-modal'],
};
</script>
